import {
  IconButton,
  makeStyles,
  Stack,
  Text,
  TooltipHost,
} from '@fluentui/react';
import clsx from 'clsx';
import { AmountTextView } from 'common/components/AmountView/AmountTextView';
import { useCommonStyles } from 'common/styles';
import Decimal from 'decimal.js';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { ColumnData } from '../columns.data';

const useStyles = makeStyles(() => ({
  container: {
    marginTop: '25px !important',
  },
  amountText: {
    textAlign: 'right',
  },
}));

interface DistributionRowTotalProps {
  columnsArray: ColumnData[];
}

export const DistributionRowTotal: React.FC<DistributionRowTotalProps> = ({
  columnsArray,
}) => {
  const styles = useStyles();
  const commonStyles = useCommonStyles();
  const watchDistribution = useWatch({ name: 'purchaseOrderItemDistribution' });

  const totalAllocation = watchDistribution.every((item: any) => {
    return item.allocationPercent === null || item.allocationPercent === 'NaN';
  })
    ? null
    : (watchDistribution.reduce((sum: Decimal, current: any) => {
        return new Decimal(sum || 0).plus(
          current.allocationPercent === null ||
            current.allocationPercent === 'NaN'
            ? 0
            : current.allocationPercent
        );
      }, new Decimal(0)) as Decimal);

  const total = watchDistribution.reduce((sum: Decimal, current: any) => {
    try {
      const distributionAmount = current.distributionAmount || '0.0';
      return new Decimal(sum || 0.0).plus(distributionAmount);
    } catch (error) {
      return sum || 0.0;
    }
  }, new Decimal(0)) as Decimal;

  if (watchDistribution.length <= 1) return null;
  else
    return (
      <>
        <Stack
          horizontal
          verticalAlign="center"
          tokens={{ childrenGap: 10 }}
          className={styles.container}
        >
          {columnsArray?.map((ele, index) => {
            switch (ele.key) {
              case 'delete':
                return null;
              case 'distributionAmount':
                return (
                  <Stack
                    key={index}
                    style={{
                      minWidth: ele.maxWidth,
                    }}
                  >
                    <AmountTextView
                      className={clsx(
                        styles.amountText,
                        commonStyles.semibold,
                        commonStyles.colorThemePrimary
                      )}
                      value={total.toNumber().toFixed(2)}
                    />
                  </Stack>
                );
              case 'allocationPercent':
                return (
                  <Stack
                    key={index}
                    style={{
                      minWidth: ele.maxWidth,
                    }}
                  >
                    {totalAllocation ? (
                      totalAllocation.toNumber() > 100 ? (
                        <Text
                          className={clsx(
                            commonStyles.colorThemeRed,
                            styles.amountText
                          )}
                        >
                          Cannot be more than 100
                        </Text>
                      ) : (
                        <Stack
                          horizontal
                          horizontalAlign="end"
                          verticalAlign="center"
                        >
                          {totalAllocation.toNumber() < 100 && (
                            <TooltipHost
                              content={"Allocation has to be '100%'"}
                            >
                              <IconButton iconProps={{ iconName: 'Warning' }} />
                            </TooltipHost>
                          )}
                          <Text
                            className={clsx(
                              commonStyles.semibold,
                              commonStyles.colorThemePrimary
                            )}
                          >
                            {totalAllocation.toNumber().toString()}
                          </Text>
                        </Stack>
                      )
                    ) : null}
                  </Stack>
                );
              default:
                return (
                  <Stack
                    key={index}
                    style={{
                      minWidth: ele.minWidth,
                    }}
                  />
                );
            }
          })}
        </Stack>
      </>
    );
};
